import Message from "../../../../../i18n/Message";
import ModalDialog from "../../../../shared/ModalDialog";
import MessageTextContainer from "../../../chats/details/MessageTextContainer";

import "./WebpageContentDialog.scss";
import { XIcon } from "lucide-react";

const WebpageContentDialog = ({ asset, onClose }) => {
  return (
    <ModalDialog onClose={onClose} className="webpage_content_dialog">
      <div className="modal_title">
        <div className="preview_header">
          <div className="preview_title">{asset.name}</div>
          <a
            href={asset.url}
            target="_blank"
            rel="noopener noreferrer"
            className="preview_url"
          >
            {asset.url}
          </a>
        </div>
      </div>
      <div className="preview_content">
        {asset.markdown ? (
          <MessageTextContainer>{asset.markdown}</MessageTextContainer>
        ) : (
          <div className="empty_preview">
            <Message id="no_content_available" />
          </div>
        )}
      </div>
      <div className="buttons">
        <button
          className="btn bg-gradient-dark"
          onClick={onClose}
          type="button"
        >
          <XIcon color="#fff" strokeWidth="2" size="18" />
          <Message id="close" />
        </button>
      </div>
    </ModalDialog>
  );
};

export default WebpageContentDialog;
